import { useEffect, useCallback } from "react";
import { useNavigate } from "react-router";
import CustomAlert from "@core/components/dialog/CustomAlert";
import { useDialog } from "@core/components/dialog/hooks/useDialog";
import { useMessage } from "@core/hooks/useMessage";

export default function JoinAlert() {
  const { isOpen, open, toggle } = useDialog({ type: "alert", name: "joinAlert" });
  const navigate = useNavigate();
  const t = useMessage();

  // 초기 마운트 발생 시에만 실행
  useEffect(() => {
    open();
  }, []);

  const loginAlertHandleClick = useCallback(() => {
    return navigate("/", { replace: true });
  }, [navigate]);

  return (
    <CustomAlert name="joinAlert" isOpen={isOpen} onOpenChange={toggle} onClick={loginAlertHandleClick}>
      {t("COMMON.JOIN_APPROVAL")}
    </CustomAlert>
  );
}
